import { render, staticRenderFns } from "./sidebarMenuShrink.vue?vue&type=template&id=4afeca1c"
import script from "./sidebarMenuShrink.vue?vue&type=script&lang=ts"
export * from "./sidebarMenuShrink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports